import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { AuthService } from "../../auth/service/auth.service";
import { MyErrorStateMatcherComponent } from "../my-error-state-matcher/my-error-state-matcher.component";

@Component({
  selector: "app-form-contact-us",
  templateUrl: "./form-contact-us.component.html",
  styleUrls: ["./form-contact-us.component.css"],
})
export class FormContactUsComponent implements OnInit {
  constructor(private authService: AuthService) { }

  nameFormControl = new FormControl("", Validators.required);
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  subjectFormControl = new FormControl("", Validators.required);
  messageFormControl = new FormControl("");

  matcher = new MyErrorStateMatcherComponent();

  result: boolean = false;
  ngOnInit(): void { }

  fnSendMessage() {
    const _name = this.nameFormControl.value;
    const _email = this.emailFormControl.value;
    const _subject = this.subjectFormControl.value;
    const _message = this.messageFormControl.value
      ? this.messageFormControl.value
      : "";

    this.authService.sendMail({
      name: _name,
      email: _email,
      subject: _subject,
      message: _message,
    });
  }
}
